"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var DRAFT_EVENTS = ['onBeforeInput', 'onBlur', 'onClick', 'onCompositionEnd', 'onCompositionStart', 'onCopy', 'onCut', 'onDragEnd', 'onDragEnter', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onFocus', 'onInput', 'onKeyDown', 'onKeyPress', 'onKeyUp', 'onMouseDown', 'onMouseUp', 'onPaste', 'onSelect'];

var _default = function _default(Component) {
  var EventBoundary = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2.default)(EventBoundary, _React$Component);

    function EventBoundary(props) {
      var _this;

      (0, _classCallCheck2.default)(this, EventBoundary);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EventBoundary).call(this, props));
      _this.handlers = DRAFT_EVENTS.reduce(function (acc, eventName) {
        acc[eventName] = function (e) {
          if (e && e.stopPropagation) {
            e.stopPropagation();
          }

          if (_this.props[eventName]) {
            _this.props[eventName](e);
          }
        };

        return acc;
      }, {});
      return _this;
    }

    (0, _createClass2.default)(EventBoundary, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, Object.assign({}, this.props, this.handlers));
      }
    }]);
    return EventBoundary;
  }(_react.default.Component);

  EventBoundary.propTypes = Object.assign({}, Component.propTypes);
  EventBoundary.defaultProps = Object.assign({}, Component.defaultProps);
  return EventBoundary;
};

exports.default = _default;
module.exports = exports.default;